import React from "react";
const useGradualQualityImageSource = (lowQualitySrc, highQualitySrc) => {
    if (!lowQualitySrc)
        return [highQualitySrc, false];
    const [src, setSrc] = React.useState(lowQualitySrc !== null && lowQualitySrc !== void 0 ? lowQualitySrc : highQualitySrc);
    React.useEffect(() => {
        const img = new Image();
        img.src = highQualitySrc;
        img.onload = () => setSrc(highQualitySrc);
    }, [lowQualitySrc, highQualitySrc]);
    return [src, src === lowQualitySrc];
};
export default useGradualQualityImageSource;
